import { useCallback, useState } from "react";

export function usePurchaseManager() {
  const [snackbar] = useState({
    open: false,
    message: "",
    severity: "info",
    persistent: false,
  });
  const hideSnackbar = useCallback(() => {}, []);
  const subscribe = useCallback(async () => ({ success: false, error: "web_stub" }), []);
  const restore = useCallback(async () => ({ success: false, error: "web_stub" }), []);
  const refreshPremium = useCallback(async () => {}, []);

  return {
    isIapAvailable: false,
    isProcessing: false,
    isPremium: false,
    snackbar,
    hideSnackbar,
    subscribe,
    restore,
    refreshPremium,
  };
}
